import { combineReducers } from 'redux';
import stuff from './stuff';
import scrolling from './scrolling';
import weather from './weather';
import loginReducer from './loginReducer';
import gallerieReducer from './gallerieReducer';
import NotificationReducer from './NotificationReducer';
import MenusReducer from './MenusReducer';
import ProfilReducer from './ProfilReducer';
import EventsReducer from './EventsReducer';
import subscribeReducer from './subscribeReducer';
import SlugReducer from './SlugReducer';
import DairiesReducer from './DairiesReducer';
import BookingReducer from './BookingReducer';

const rootReducer = combineReducers({
  stuff,
  scrolling,
  weather,
  login: loginReducer,
  gallerie: gallerieReducer,
  notification: NotificationReducer,
  menus: MenusReducer,
  profil: ProfilReducer,
  events: EventsReducer,
  favoris: subscribeReducer,
  slug: SlugReducer,
  dairy: DairiesReducer,
  booking: BookingReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js